<template>
    <section class="odocs-spaced">
        <p>
            <o-button label="Normal" />
            <o-button label="Disabled" disabled />
            <o-button label="Rounded" rounded />
        </p>
        <p>
            <o-button label="Expanded" expanded />
        </p>
    </section>
</template>
